import React from 'react';
import {useSelector, useDispatch} from "react-redux";
import {get, find} from 'lodash';
import classNames from 'classnames';

import {FILTER_1} from "../../../../../reducers/performance_reducers";
import {
    SetDashboardFiltersAction,
    CleanDashboardDataAction
} from "../../../../../actions/performance_actions";

// tmp for computing caps
let cap_data;

export default function () {
    const dispatch = useDispatch();

    const dashboard_filters = useSelector(state => state.dashboard_filters);
    const dashboard_school_filter = useSelector(state => state.dashboard_school_filter);

    const filters = dashboard_filters[FILTER_1];

    if (!dashboard_school_filter) {
        return null;
    }

    const dashboard_data = useSelector(state => state.dashboard_data);
    const school_stats = get(dashboard_data, 'stats.school', []);

    const selected_school_id = get(filters.school_id, 0);

    const onClick = (school_id) => () => {
        if (school_id == selected_school_id) {
            return;
        }
        const dashboard_filters_copy = JSON.parse(JSON.stringify(dashboard_filters));
        if (school_id) {
            dashboard_filters_copy[FILTER_1]['school_id'] = [school_id];
        } else {
            dashboard_filters_copy[FILTER_1]['school_id'] = [];
        }
        dispatch(CleanDashboardDataAction());
        dispatch(SetDashboardFiltersAction(dashboard_filters_copy));
    }

    const renderCaps = (school) => {
        const this_stats = find(school_stats, {school_id: school.school_id});
        if (!this_stats) {
            return null;
        }
        const n = Math.ceil((this_stats.met + this_stats.exceeded) / this_stats.total * 100 / 15);
        const render_caps = Array(Math.min(n, 5)).fill(1).map((x, k) => {
            return (
                <i key={k} className="pam-selection-cap fas fa-graduation-cap"></i>
            );
        });

        return (
            <div className="">
                {render_caps}
            </div>
        );
    }

    const renderCaps2 = (school) => {
        const this_stats = find(school_stats, {school_id: school.school_id});
        if (!this_stats) {
            return null;
        }
        return (
            <div className="flex-row flex-v-center flex-gap-5">
                <i className="pam-selection-cap fas fa-user"></i>
                <div>{`${this_stats.student_num}`}</div>
            </div>
        );
    }

    const renderCaps3 = (school) => {
        const this_stats = find(school_stats, {school_id: school.school_id});
        if (!this_stats) {
            return null;
        }
        return (
            <div className="flex-row flex-v-center flex-gap-5">
                <i className="pam-selection-cap fas fa-pen"></i>
                <div>{`${this_stats.total}`}</div>
            </div>
        );
    }

    const renderCaps4 = (school) => {
        const this_stats = find(school_stats, {school_id: school.school_id});
        if (!this_stats) {
            return null;
        }
        return (
            <div className="flex-row flex-v-center flex-gap-5">
                <i className="pam-selection-cap fas fa-trophy"></i>
                <div>{`${this_stats.met + this_stats.exceeded} / ${this_stats.total}`}</div>
            </div>
        );
    }

    const render_schools = dashboard_school_filter.map((school) => {
        const class_names = classNames("pam-selection-one-item flex-row flex-gap-10", {
            "pam-selection-one-item-selected": school.school_id == selected_school_id
        });
        return (
            <div key={school.school_id} className={class_names} onClick={onClick(school.school_id)}>
                <div>
                    {`${school.school_name}`}
                </div>
                {renderCaps(school)}
            </div>
        );
    });

    const class_names_all = classNames("pam-selection-one-item", {
        "pam-selection-one-item-selected": selected_school_id == undefined
    });

    return (
        <div className="flex-auto pam-selection-scroll">
            <div className="flex-column flex-gap-5">
                <div className={class_names_all} onClick={onClick(undefined)}>
                    {`All Schools`}
                </div>

                {render_schools}
            </div>
        </div>
    );
}
